// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__SiU6w","content":"styles_content__3MZb6","checkbox":"styles_checkbox__3tIyu","checkboxLabel":"styles_checkboxLabel__fomyy"};